import { createAction } from 'redux-act';

import Guest from '@/models/interfaces/Guest';

import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchCompanyGuestsPayload extends FetchPayload {
  companyUuid: string;
}
export const fetchCompanyGuests = createAction<FetchCompanyGuestsPayload>('FETCH_COMPANY_GUESTS');
export interface CompanyGuestsFetchedPayload extends TimestampPayload {
  guests: Guest[];
}
export const companyGuestsFetched = createAction<CompanyGuestsFetchedPayload>('COMPANY_GUESTS_FETCHED');
export interface CompanyGuestsFetchFailedPayload extends TimestampPayload {
  companyUuid: string;
}
export const companyGuestsFetchFailed = createAction<CompanyGuestsFetchFailedPayload>('COMPANY_GUESTS_FETCH_FAILED');
